import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import BridgeBook from "../book/bridge-book";
import BookGrid from "../bookviews/book-grid";
import {
  actions as bridgeActions,
  selectors as bridgeSelectors
} from "../../../../redux/bridge";
import { actions as modalActions } from "../../../../redux/modals";
import { selectors as licenseSelectors } from "../../../../redux/license";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as routerActions } from "../../../../redux/router";
import {
  styledMedia,
  withAllMatches
} from "../../../components/mediaquery/breakpoints";
import { EDGE_SPACING, EDGE_SPACING_MED } from "../bookviews/consts";
import { t } from "../../../core/translate";
import PageTitle from "../../../utils/page-title";
import SubscriptionCategoryLanes from "./lanes/subscription-categories";
import { trendParams } from "../../../../redux/bridge/utils";
import PopularLane from "./lanes/popular";
import RecommendedLane from "./lanes/recommended";
import RecentlyAddedLane from "./lanes/recently-added";
import MustRead from "./branding/must-read";
import TrendingFeature from "./branding/trending-feature";
import HeroTitle from "./hero-title";
import DefaultSubscriptionsView from "./default-subscriptions-view";
import RecommendBySubjectLanes from "./lanes/recommend-by-subject";

const Styled = {
  HeroContentCentered: styled.div`
    margin: 0 auto;
    padding: 64px ${EDGE_SPACING}px 36px ${EDGE_SPACING}px;
    max-width: 1258px;
    position: relative;
    z-index: 1;
    
    ${styledMedia.medium`
      padding: 26px ${EDGE_SPACING_MED}px 32px ${EDGE_SPACING_MED}px;
    `}
    
    ${styledMedia.small`
      padding: 0;
    `}
    
    /* Search container will take care of this */
    ${props => props.native && `padding-top: 0 !important`}
  `,
  HeroTitleContainer: styled.div`
    margin-bottom: 10px;
  `
};

class LargeBrandedSubscriptionView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridAssets: null,
      showSmallSubSearch: false,
      headerLabel: ""
    };
    this.collapseView = this.collapseView.bind(this);
    this.expandSwimlane = this.expandSwimlane.bind(this);
    this.showAllSubscriptions = this.showAllSubscriptions.bind(this);
  }

  componentDidMount() {
    this.fetchLists(this.brandedListParams());
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.licenseUpdating && prevProps.licenseUpdating) {
      this.fetchLists(this.brandedListParams());
    }
  }

  fetchLists(params) {
    this.props.fetchLists(params);
  }

  brandedListParams() {
    const {
      popularSwimlaneEnabled,
      recommendedSwimlaneEnabled,
      addedSwimlaneEnabled,
      subscriptionVbid
    } = this.props;
    const listsToFetch = [];
    if (popularSwimlaneEnabled) {
      listsToFetch.push(trendParams("popular", subscriptionVbid));
    }
    if (recommendedSwimlaneEnabled) {
      listsToFetch.push(trendParams("recommended", subscriptionVbid));
    }
    if (addedSwimlaneEnabled) {
      listsToFetch.push(trendParams("added", subscriptionVbid));
    }
    return listsToFetch;
  }

  expandSwimlane(assets, headerLabel) {
    this.setState({
      gridAssets: assets,
      headerLabel: headerLabel
    });
  }

  collapseView() {
    this.setState({
      gridAssets: null
    });
  }

  showAllSubscriptions() {
    return <DefaultSubscriptionsView />;
  }

  render() {
    const { gridAssets, headerLabel } = this.state;
    const {
      subscriptionVbid,
      isMedium,
      isSmall,
      showTopPopular,
      popularTitleKey,
      subscriptionCategoryLanes,
      popular,
      popularSwimlaneEnabled,
      popularLoading,
      recommendedSwimlaneEnabled,
      showTopRecommended,
      recommendedTitleKey,
      recommended,
      recommendedLoading,
      addedLoading,
      addedTitleKey,
      added,
      addedSwimlaneEnabled,
      routePush
    } = this.props;

    const pageTitle = gridAssets
      ? t("explore.explore-category", "Explore Category", {
          category: headerLabel
        })
      : t("page.explorer", "Explore");

    if (gridAssets) {
      return (
        <BookGrid
          BookObject={BridgeBook}
          onHeaderClick={this.collapseView}
          isbns={gridAssets.map(b => ({ isbn: b.vbid }))}
          headerLabel={headerLabel}
          count={gridAssets.length}
          backArrow={t("page.explorer", "Explore")}
        />
      );
    } else {
      const trendingCount = isSmall ? 0 : 3;
      return (
        <div>
          <PageTitle title={pageTitle} key="title" />
          <Styled.HeroTitleContainer>
            <HeroTitle
              subscriptionVbid={subscriptionVbid}
              backToExplore={() => routePush("/explore")}
              showSearch={true}
            />
          </Styled.HeroTitleContainer>
          {recommendedSwimlaneEnabled && (
            <RecommendedLane
              swimlaneStart={showTopRecommended ? 1 : 0}
              recommendedLoading={recommendedLoading}
              recommended={recommended}
              recommendedTitleKey={recommendedTitleKey}
              expandSwimlane={this.expandSwimlane}
            />
          )}
          {showTopRecommended && (
            <MustRead asset={recommended[0]} isMedium={isMedium} />
          )}
          {popularSwimlaneEnabled && (
            <PopularLane
              popularTitleKey={popularTitleKey}
              popular={popular}
              popularLoading={popularLoading}
              expandSwimlane={this.expandSwimlane}
              trendingCount={trendingCount}
            />
          )}
          {showTopPopular && (
            <TrendingFeature
              subscriptionVbid={subscriptionVbid}
              popular={!isMedium ? popular.slice(0, trendingCount) : []}
              onViewAll={() => this.expandSwimlane(popular, t(popularTitleKey))}
              isMedium={isMedium}
            />
          )}
          {addedSwimlaneEnabled && (
            <RecentlyAddedLane
              addedLoading={addedLoading}
              addedTitleKey={addedTitleKey}
              added={added}
              expandSwimlane={this.expandSwimlane}
            />
          )}
          {subscriptionCategoryLanes && (
            // show lanes defined for this subscription
            <SubscriptionCategoryLanes
              lanes={subscriptionCategoryLanes}
              subscriptionVbid={subscriptionVbid}
              expandSwimlane={this.expandSwimlane}
            />
          )}
          {!subscriptionCategoryLanes && (
            <RecommendBySubjectLanes
              subscriptionVbid={subscriptionVbid}
              expandSwimlane={this.expandSwimlane}
            />
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, props) => ({
  licenseUpdating: licenseSelectors.isLicenseUpdating(state),
  popularSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.popular"
  ),
  popularTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.popularTitleKey",
    "explore.trending"
  ),
  showTopPopular: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopPopular",
    true
  ),
  recommendedSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.recommended"
  ),
  recommendedTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.recommendedTitleKey",
    "explore.top-picks"
  ),
  showTopRecommended: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopRecommended",
    true
  ),
  recommended: bridgeSelectors.getAssets(
    state,
    trendParams("recommended", props.subscriptionVbid)
  ),
  recommendedLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("recommended", props.subscriptionVbid)
  ),
  popular: bridgeSelectors.getAssets(
    state,
    trendParams("popular", props.subscriptionVbid)
  ),
  popularLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("popular", props.subscriptionVbid)
  ),
  addedSwimlaneEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.added"
  ),
  added: bridgeSelectors.getAssets(
    state,
    trendParams("added", props.subscriptionVbid)
  ),
  addedTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.Swimlanes.addedTitleKey",
    "explore.recently-added"
  ),
  addedLoading: bridgeSelectors.isAssetsFetching(
    state,
    trendParams("added", props.subscriptionVbid)
  ),

  subscriptionCategoryLanes: bridgeSelectors.getSubscriptionCategoryLanes(
    state,
    props.subscriptionVbid
  )
});

const mapDispatchToProps = dispatch => ({
  fetchLists: lists => dispatch(bridgeActions.fetchLists(lists)),
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
  routePush: path => dispatch(routerActions.push(path))
});

export default withAllMatches(
  withTheme(
    connect(mapStateToProps, mapDispatchToProps)(LargeBrandedSubscriptionView)
  )
);
